<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="耳标编号">
              <a-input placeholder="请输入耳标编号" v-model="queryParam.tagsNumber"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="耳标类型">
              <j-dict-select-tag type="radio" v-model="queryParam.tagsType" dictCode="tags_type" placeholder="请选择耳标类型"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="当前状态">
              <j-dict-select-tag type="radio" v-model="queryParam.statusing" dictCode="tag_statusing"
                                 placeholder="请选择当前状态"/>
            </a-form-item>
          </a-col>
          <!--          <template v-if="toggleSearchStatus">-->
          <!--            <a-col :xl="10" :lg="11" :md="12" :sm="24">-->
          <!--              <a-form-item label="创建时间">-->
          <!--                <j-date placeholder="请选择开始日期" class="query-group-cust" v-model="queryParam.createTime_begin"></j-date>-->
          <!--                <span class="query-group-split-cust"></span>-->
          <!--                <j-date placeholder="请选择结束日期" class="query-group-cust" v-model="queryParam.createTime_end"></j-date>-->
          <!--              </a-form-item>-->
          <!--            </a-col>-->
          <!--          </template>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                            <a-button type="primary" @click="searchReset" icon="reload"
                                      style="margin-left: 8px">重置</a-button>
              <!--              <a @click="handleToggleSearch" style="margin-left: 8px">-->
              <!--                {{ toggleSearchStatus ? '收起' : '展开' }}-->
              <!--                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>-->
              <!--              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!--     操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button @click="handleAddBatch" type="primary" icon="plus">批量新增</a-button>
      <!--      <a-button type="primary" icon="download" @click="handleExportXls('beef_tags')">导出</a-button>-->
      <!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl"-->
      <!--                @change="handleImportExcel">-->
      <!--        <a-button type="primary" icon="import">导入</a-button>-->
      <!--      </a-upload>-->
      <!-- 高级查询区域
    <j-super-query :fieldList="superFieldList" ref="superQueryModal"
                   @handleSuperQuery="handleSuperQuery"></j-super-query>
    <a-dropdown v-if="selectedRowKeys.length > 0">
      <a-menu slot="overlay">
        <a-menu-item key="1" @click="batchDel">
          <a-icon type="delete"/>
          删除
        </a-menu-item>
      </a-menu>
      <a-button style="margin-left: 8px"> 批量操作
        <a-icon type="down"/>
      </a-button>
    </a-dropdown>-->
    </div>

    <!--     table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt=""
               style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <beef-tags-modal ref="modalForm" @ok="modalFormOk"></beef-tags-modal>
    <a-modal
      title="请填写耳标数"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div style="color: red">注意：每一万条大概用时10分钟</div>
      <div style="display: flex">
        <div>生成数量：</div>
        <a-input-number style="margin-left: 10px" v-model="number" :min="1" :max="10000"/>
      </div>
      <div style="display: flex;margin-top: 10px">
        <div>耳标类型：</div>
        <j-dict-select-tag style="margin-left: 10px" type="radio" v-model="tagsType" dictCode="tags_type"
                           placeholder="请选择耳标类型"/>
        <!--        <a-radio-group name="radioGroup" v-model="tagTypes">-->
        <!--          <a-radio value="1">-->
        <!--            A标-->
        <!--          </a-radio>-->
        <!--          <a-radio value="2">-->
        <!--            B标-->
        <!--          </a-radio>-->
        <!--        </a-radio-group>-->
      </div>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BeefTagsModal from './modules/BeefTagsModal'
  import { getAction } from '@/api/manage'
  //引入JS方法
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'BeefTagsList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      BeefTagsModal
    },
    data() {
      return {
        description: 'beef_tags管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function(t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '耳标编号',
            align: 'center',
            sorter: true,
            dataIndex: 'tagsNumber'
          },
          {
            title: '耳标类型',
            align: 'center',
            dataIndex: 'tagsType',
            customRender: (text) => {
              return filterDictTextByCache('tags_type', text)
            }
          },
          {
            title: '当前状态',
            align: 'center',
            dataIndex: 'statusing',
            customRender: (text) => {
              return filterDictTextByCache('tag_statusing', text)
            }
          },
          {
            title: '所属用户',
            align: 'center',
            dataIndex: 'useUserId_dictText'
          },
          {
            title: '所属镇街',
            align: 'center',
            dataIndex: 'useTown_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/beef/beefTags/list',
          addBatch: '/beef/beefTags/addBatch',
          delete: '/beef/beefTags/delete',
          deleteBatch: '/beef/beefTags/deleteBatch',
          exportXlsUrl: '/beef/beefTags/exportXls',
          importExcelUrl: 'beef/beefTags/importExcel'

        },
        dictOptions: {},
        superFieldList: [],
        visible: false,
        confirmLoading: false,
        tagsType: '1', number: 1000
      }
    },
    created() {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function() {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      handleAddBatch() {
        this.visible = true
      },
      handleOk() {
        this.confirmLoading = true
        getAction(this.url.addBatch, { tagsType: this.tagsType, number: this.number }).then(res => {
          if (res.success) {
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        }).finally(f => {
          this.confirmLoading = false
          this.visible = false
          this.loadData()
        })
      },
      handleCancel() {
        this.visible = false
      },
      initDictConfig() {
      },
      getSuperFieldList() {
        let fieldList = []
        fieldList.push({ type: 'int', value: 'tagsNumber', text: '耳标编号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'tagsType', text: '耳标类型', dictCode: '' })
        fieldList.push({ type: 'string', value: 'statusing', text: '当前状态', dictCode: '' })
        fieldList.push({ type: 'date', value: 'createTime', text: '创建时间' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>